function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "BF4796C3-08D7-44FE-BCBA-E68B5E37556B");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Home",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "ATF_V2-3_1200px",
  transform: "translate(-917.000000, -412.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-8",
  transform: "translate(898.000000, 120.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-7",
  transform: "translate(18.000000, 291.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-4"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.670299,16.2191287 C8.23058037,17.2691041 15.9141399,16.2191287 17.4650146,10.5591255 C19.0158892,4.89912233 6.3795172,3.45891705 4.670299,6.78579007 C2.96108081,10.1126631 1.11001764,15.1691534 4.670299,16.2191287 Z",
  id: "Path-2",
  fill: "#E8C230"
}), /*#__PURE__*/React.createElement("g", {
  id: "outline-loyalty-24px"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "0 0 16.32 0 16.32 16.32 0 16.32"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.5588,7.8744 L8.4388,1.7544 C8.194,1.5096 7.854,1.36 7.48,1.36 L2.72,1.36 C1.972,1.36 1.36,1.972 1.36,2.72 L1.36,7.48 C1.36,7.854 1.5096,8.194 1.7612,8.4456 L7.8812,14.5656 C8.126,14.8104 8.466,14.96 8.84,14.96 C9.214,14.96 9.554,14.8104 9.7988,14.5588 L14.5588,9.7988 C14.8104,9.554 14.96,9.214 14.96,8.84 C14.96,8.466 14.8036,8.1192 14.5588,7.8744 Z M8.84,13.6068 L2.72,7.48 L2.72,2.72 L7.48,2.72 L7.48,2.7132 L13.6,8.8332 L8.84,13.6068 L8.84,13.6068 Z",
  id: "Shape",
  fill: "#220C89",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#220C89",
  fillRule: "nonzero",
  cx: 4.42,
  cy: 4.42,
  r: 1.02
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.052,8.534 C6.052,8.9216 6.2084,9.2616 6.46,9.52 L8.84,11.9 L11.22,9.52 C11.4716,9.2684 11.628,8.9148 11.628,8.534 C11.628,7.7656 11.0024,7.14 10.234,7.14 C9.8464,7.14 9.4996,7.2964 9.248,7.548 L8.84,7.956 L8.432,7.5548 C8.1804,7.2964 7.8268,7.14 7.446,7.14 C6.6776,7.14 6.052,7.7656 6.052,8.534 Z",
  id: "Path",
  fill: "#220C89",
  fillRule: "nonzero"
})))))));

var SvgGroup4 = function SvgGroup4(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "16px",
    viewBox: "0 0 17 16",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGroup4, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Group4.a7eb87da.svg";
export { ForwardRef as ReactComponent };